import React from 'react';
import {CircularProgress, RaisedButton, TextField} from "material-ui";
import request from "../../../../config/axios-config";
import {Constants} from "../../../../constants";
import * as ErrorAction from "../../../../redux/action/error-action";
import {connect} from "react-redux";
import * as validator from "../../../../general/validators/validator";

class AuthorityPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activityDomain: "",
            address: "",
            authorityType: "",
            city: "",
            contactEmail: "",
            county: "",
            cui: "",
            name: "",
            zipCode: "",
            id: null,
            error: {},
            loading: true,
            saving: false,
            successful: false,
            approvalPrintLayout: "CLASSIC",
            printRegistrationBox: false,
            savingPrint: false,
            printSaved: false,
        }
    }

    componentDidMount() {
        request({
            url: Constants.SERVER_ENDPOINT + "/authority",
            method: 'GET',
        }).then(t => {
            let details = t.data.companyDetails;
            this.setState({
                activityDomain: details.activityDomain,
                address: details.address,
                authorityType: details.authorityType,
                city: details.city,
                contactEmail: details.contactEmail,
                county: details.county,
                cui: details.cui,
                name: details.name,
                zipCode: details.zipCode,
                id: details.id,
                approvalPrintLayout: t.data.approvalPrintLayout || "CLASSIC",
                printRegistrationBox: !!t.data.printRegistrationBox,
                error: {
                    cui: null
                },
                loading: false
            });
        }).catch(err => {
            this.setState({
                loading: false
            });
            this.props.showError("A aparut o eroare. Va rog sa reincercati!");
        });
    }

    componentWillUnmount() {
        this.props.hideError();
    }

    onSave = () => {
        if (!this.validateInput()) {
            return;
        }
        this.setState({
            saving: true
        });
        let jsonData = {
            activityDomain: this.state.activityDomain,
            address: this.state.address,
            authorityType: this.state.authorityType,
            city: this.state.city,
            contactEmail: this.state.contactEmail,
            county: this.state.county,
            cui: this.state.cui,
            name: this.state.name,
            zipCode: this.state.zipCode,
            id: this.state.id
        };

        request({
            url: Constants.SERVER_ENDPOINT + "/authority",
            method: 'POST',
            data: jsonData
        }).then(t => {
            this.setState({
                saving: false,
                successful: true
            });
        }).catch(err => {
            this.setState({
                saving: false,
                successful: false,
            });
            this.props.showError("A aparut o eroare. Va rog sa reincercati!");
        });
    };

    onSavePrintSettings = () => {
        this.setState({savingPrint: true, printSaved: false});
        request({
            url: Constants.SERVER_ENDPOINT + "/authority/print-settings",
            method: 'POST',
            data: {
                approvalPrintLayout: this.state.approvalPrintLayout,
                printRegistrationBox: this.state.printRegistrationBox,
            }
        }).then(() => {
            this.setState({savingPrint: false, printSaved: true});
        }).catch(() => {
            this.setState({savingPrint: false});
            this.props.showError("A aparut o eroare. Va rog sa reincercati!");
        });
    };

    validateInput = () => {
        let isOk = true;
        let error = {};

        if (validator.isEmpty(this.state.cui)) {
            error.cui = "Lipseste CUI";
            isOk = false;
        }
        if (validator.isEmpty(this.state.name)) {
            error.name = "Lipseste numele";
            isOk = false;
        }
        if (!validator.isEmpty(this.state.contactEmail) && !validator.isValidEmail(this.state.contactEmail)) {
            error.contactEmail = "Formatul emailului e gresit!";
            isOk = false;
        }

        this.setState({
            error: error,
        });

        return isOk;
    };


    render() {
        return (
            <div style={{textAlign: 'center'}}>
                {
                    this.state.loading
                        ? <CircularProgress style={{marginTop: '50px'}} size={80}/>
                        : <div>
                            <div>
                                <TextField
                                    floatingLabelText={"Denumire"}
                                    value={this.state.name}
                                    errorText={this.state.error.name}
                                    onChange={(e) => this.setState({name: e.target.value})}
                                />
                            </div>
                            <div>
                                <TextField
                                    floatingLabelText={"CUI"}
                                    errorText={this.state.error.cui}
                                    value={this.state.cui}
                                    onChange={(e) => this.setState({cui: e.target.value})}
                                />
                            </div>
                            <div>
                                <TextField
                                    floatingLabelText={"Tip autoritate"}
                                    value={this.state.authorityType}
                                    onChange={(e) => this.setState({authorityType: e.target.value})}
                                />

                            </div>
                            <div>
                                <TextField
                                    floatingLabelText={"Domeniu activitate"}
                                    value={this.state.activityDomain}
                                    onChange={(e) => this.setState({activityDomain: e.target.value})}
                                />
                            </div>
                            <div>
                                <TextField
                                    floatingLabelText={"Judet"}
                                    value={this.state.county}
                                    onChange={(e) => this.setState({county: e.target.value})}
                                />
                            </div>
                            <div>
                                <TextField
                                    floatingLabelText={"Localitate"}
                                    value={this.state.city}
                                    onChange={(e) => this.setState({city: e.target.value})}
                                />
                            </div>
                            <div>
                                <TextField
                                    floatingLabelText={"Adresa"}
                                    value={this.state.address}
                                    onChange={(e) => this.setState({address: e.target.value})}
                                />
                            </div>
                            <div>
                                <TextField
                                    floatingLabelText={"Cod Postal"}
                                    value={this.state.zipCode}
                                    onChange={(e) => this.setState({zipCode: e.target.value})}
                                />
                            </div>
                            <div>
                                <TextField
                                    floatingLabelText={"Adresa email de contact"}
                                    errorText={this.state.error.contactEmail}
                                    value={this.state.contactEmail}
                                    onChange={(e) => this.setState({contactEmail: e.target.value})}
                                />
                            </div>

                            {this.state.saving && <div><CircularProgress style={{marginTop: '50px'}}/></div>}

                            <div>{this.state.successful && <strong>Datele au fost schimbate cu succes!</strong>}</div>

                            <div>
                                <RaisedButton
                                    style={{marginTop: '20px'}}
                                    primary
                                    label={"Salveaza"}
                                    onClick={() => this.onSave()}/>
                            </div>

                            <div style={{marginTop: '40px'}}>
                                <h3>Tipărirea referatului</h3>
                                <div style={{marginTop: '10px'}}>
                                    <label>
                                        Semnături:{" "}
                                        <select
                                            value={this.state.approvalPrintLayout}
                                            onChange={(e) => this.setState({approvalPrintLayout: e.target.value, printSaved: false})}>
                                            <option value="CLASSIC">Clasic (4 semnături pe poziții fixe)</option>
                                            <option value="ROUTE">Traseu configurabil (toți pașii fluxului)</option>
                                        </select>
                                    </label>
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={this.state.printRegistrationBox}
                                            disabled={this.state.approvalPrintLayout !== "ROUTE"}
                                            onChange={() => this.setState({printRegistrationBox: !this.state.printRegistrationBox, printSaved: false})}/>
                                        {" "}Spațiu pentru Nr. înregistrare (completat de mână)
                                    </label>
                                </div>
                                {this.state.savingPrint && <div><CircularProgress style={{marginTop: '20px'}}/></div>}
                                <div>{this.state.printSaved && <strong>Setările de tipărire au fost salvate!</strong>}</div>
                                <RaisedButton
                                    style={{marginTop: '20px'}}
                                    primary
                                    label={"Salveaza tiparirea"}
                                    onClick={() => this.onSavePrintSettings()}/>
                            </div>
                        </div>
                }
            </div>
        )
    }

}

function mapStateToProps(state, ownProps) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        showError: (text) => dispatch(ErrorAction.showError(text)),
        hideError: () => dispatch(ErrorAction.hideError())
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AuthorityPage)